import { BiMapContext } from '@rimbu/bimap/custom';
import { HashMap } from '@rimbu/hashed';
function createContext(options) {
    return Object.freeze(new BiMapContext(options?.keyValueContext ?? HashMap.defaultContext(), options?.valueKeyContext ?? HashMap.defaultContext()));
}
const _defaultContext = createContext();
export const BiMap = Object.freeze({
    ..._defaultContext,
    createContext,
    defaultContext() {
        return _defaultContext;
    },
});
//# sourceMappingURL=interface.mjs.map